import { useContextState } from "../../../../../../../../hooks/theme"

export const useStyles = () => {
  const { colors } = useContextState()
  return {
    rightBox: (color: string) => ({
      backgroundColor: color,
      width: '20px',
      borderBottomRightRadius: '4px',
      borderTopRightRadius: '4px'
    }),
  }
}
